/**
 * @fileoverview Teacher Signup page exports
 */

export { TeacherSignup } from './TeacherSignup'
